import React from 'react';
import { useUser } from '../../contexts/UserContext';
import { useAuthModal } from '../../contexts/AuthModalContext';
import { twMerge } from 'tailwind-merge';
import { SimpleListing } from '@th/shared/src/types/SimpleListing';
import Link from 'next/link';
import { featureFlags } from '../../utils/featureFlags';

type Props = {
  listing: SimpleListing;
  enabled?: boolean;
};

export default function ListingInfoBadge({ listing, enabled = true }: Props) {
  const { isLoggedIn, user } = useUser();
  const { openAuthModal } = useAuthModal();

  if (listing.isPowerOfSale) {
    return (
      <div className="absolute bottom-3 left-3">
        <p className="text-white px-3 py-2 bg-orange rounded-xl mb-0">
          Power of Sale
        </p>
      </div>
    );
  }

  if (listing.isFsbo) {
    return (
      <div className="absolute bottom-3 left-3">
        <p className="text-white px-3 py-2 bg-orange rounded-xl mb-0">
          For Sale By Owner
        </p>
      </div>
    );
  }

  if (featureFlags.SHOW_OFFER_DATES && listing.isSoldWithBullyOffer()) {
    return (
      <div className="absolute bottom-3 left-3">
        <p className="text-white px-3 py-2 bg-redOrange rounded-xl mb-0">
          Sold with bully offer
        </p>
      </div>
    );
  }

  if (featureFlags.SHOW_OFFER_DATES && listing.shouldDisplayOfferDate()) {
    return (
      <div className="absolute bottom-3 left-3">
        <div
          onClick={() => {
            if (!isLoggedIn && enabled) {
              openAuthModal();
            }
          }}
          className={twMerge(
            'text-white px-3 py-2 bg-redOrange rounded-xl',
            !isLoggedIn && enabled && 'cursor-pointer hover:underline',
          )}
        >
          Offer date:{' '}
          {isLoggedIn
            ? listing.offerDateRelativeToTodayText()
            : 'Sign in to see'}
        </div>
      </div>
    );
  }

  // NOTE: We're hiding cashback content for now, but we may decide to bring it back for some web users in the future
  // if (listing.isSale() && !user?.isVerifiedAgent()) {
  //   return (
  //     <div className="absolute bottom-3 left-3">
  //       <Link
  //         target="_blank"
  //         href={`/membership`}
  //         aria-label="Open cashback details page"
  //       >
  //         <div
  //           onClick={() => {
  //             console.log('Clicked!');
  //           }}
  //           className={twMerge(
  //             'text-black px-3 py-2 bg-lightOrange rounded-xl',
  //             'cursor-pointer',
  //           )}
  //         >
  //           {`Get ${(listing.listPrice * 0.025).formatAsPrice()} cashback`}
  //         </div>
  //       </Link>
  //     </div>
  //   );
  // }

  return null;
}
